module.exports = __webpack_public_path__ + "img/canva.c9fee248.png";